import styled, { css } from 'styled-components';
import { AvatarSizes } from '../../atoms/VHProfileImage/VHProfileImage';

export const ProfileImageArea = styled.div`
  grid-row: 1 / 3;
  grid-column: 1;
  width: 100%;
`;

export const ProfileName = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  row-gap: 0.6rem;
`;

export const ProfileNameText = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`;

export const ProfileDescription = styled.div`
  grid-column: 2 / 3;
  grid-row: 2;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  font-size: 13px;
`;

export const ProfileInfoGrid = styled.div`
  display: grid;
  grid-template-columns: ${AvatarSizes.MEDIUM.width + 'px'} 1fr;
  column-gap: 1rem;
  padding: 0.75rem;
  grid-template-rows: 1fr;
  align-items: center;
  border-radius: 20px;
  background: #fff;
  pointer-events: all;
  @media screen and (max-width: 1500px) {
    padding: 0;
    border-radius: 28px;
    display: block;
    ${ProfileNameText}, ${ProfileImageArea} {
      display: none;
    }
  }
  padding: 0;
  border-radius: 28px;
  display: block;
  ${ProfileNameText}, ${ProfileImageArea} {
    display: none;
  }
`;
